angular.
module("dx.webapp.api").
factory("dxApiV1GradingMatrix", function apiV1GradingMatrixService(
	$http,
	$httpParamSerializer
) {
	"use strict";

	var baseUrl = "/api/v1/gradingmatrix/";

	function list(archived) {
		return $http.get(baseUrl + "list?" + $httpParamSerializer({archived: archived ? archived : false}));
	}

	function save(matrix) {
		return $http.post(baseUrl + "save", matrix);
	}

	return {
		list: list,
		save: save,
	};
});
